import { useUnit } from "effector-react"

import { transcriptTranslationModel } from "../../models/transcript-translation"
import { buildTranslateFromOptions, buildTranslateToOptions } from "../../shared/helpers"

export const useInterrelatedOptions = () => {
  const formValue = useUnit(transcriptTranslationModel.$formValue)
  const availableSpeechLanguages = useUnit(transcriptTranslationModel.$availableSpeechLanguages)

  const { translate_from_languages, translate_to_language } = formValue

  const optionsFrom = buildTranslateFromOptions(availableSpeechLanguages, translate_to_language)
  const optionsTo = buildTranslateToOptions(translate_from_languages)

  return { optionsFrom, optionsTo }
}
